module.exports = __webpack_public_path__ + "static/img/DIYStep2.56363870.jpg";